import React, { useState } from "react";
import { Button, Flex, Text } from "@theorgchartdev/storybook";
import { handleCopyToClipboard } from "@/Utils/Misc";
import { appstr } from "@coreapp/utils/appstr";

export const CopyDisplayText = props => {
  const displayText = props?.value;

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    handleCopyToClipboard(displayText);
    setCopied(true);
  };

  const textProps = { size: "small", ...props?.textProps };

  return (
    <div>
      {displayText && (
        <Flex gap={"4px"} direction={"column"}>
          {props?.label && (
            <Text {...textProps} colorModifier={"grey"}>
              {props.label}
            </Text>
          )}
          <Flex gap={"4px"} alignItems={"center"}>
            <Text {...textProps} modifier={"bold"}>
              {displayText}
            </Text>
            <Button
              iconOnly
              iconProps={{ name: copied ? "clipboard-check" : "clipboard", size: "small" }}
              onClick={handleCopy}
              tooltipProps={{ message: appstr("Copy") }}
            />
          </Flex>
        </Flex>
      )}
    </div>
  );
};
